// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DCt5oKNbwFRDVDVm03di{background-position:center;background-repeat:no-repeat;background-size:cover;display:block;height:154px;margin-bottom:15px;text-decoration:none}.LF7KWxrHJFLN7hhAs_EZ{margin-bottom:5px}.VjJVdcsWuracAKG5L9aZ{color:#595358;display:block;font-size:11px;margin-bottom:5px;text-align:right;text-decoration:none}.UAJwgrRAo2yAJp33bZTD{color:#d6d0d5}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sponsoredWikiCard3ColumnImage": `DCt5oKNbwFRDVDVm03di`,
	"sponsoredWikiCard3ColumnImageSponsoredLabel": `LF7KWxrHJFLN7hhAs_EZ`,
	"sponsoredWikiCard3ColumnLabel": `VjJVdcsWuracAKG5L9aZ`,
	"sponsoredWikiCard3ColumnLabelDark": `UAJwgrRAo2yAJp33bZTD`
};
export default ___CSS_LOADER_EXPORT___;
